import React, { useState, useEffect } from "react";
import Moment from "moment";
import { t } from "../../../i18n";
import { ArrowRightSM, Chevron, substring } from "../normalizer";
import CustomButton from "../shared/CustomButton";

const months = ["jan.", "fev.", "mar.", "abr.", "mai.", "jun.",
                  "jul.", "ago.", "set.", "out.", "nov.", "dez."];

const Preview = ({ announcement, limitText }) => {
  const dateLabel = `${new Date(announcement.created_at).getDate()} ${months[new Date(announcement.created_at).getMonth()]}`;
  const [isBelowTablet, setIsBelowTablet] = useState(false);
  let normlimitText = limitText;
  useEffect(() => {
    const updateDeviceType = () => {
      setIsBelowTablet(window.innerWidth < 740);
    };

    window.addEventListener('resize', updateDeviceType);
    updateDeviceType();

    return () => window.removeEventListener('resize', updateDeviceType);
  }, []);

  const size = isBelowTablet ? 'rectangular_thumbnail_image' : 'square_thumbnail_image';
  if (isBelowTablet) {
    normlimitText = 60;
  }

  const croppedImageKey = size.replace('image', 'cropped_image');
  const imageUrl = announcement.image[croppedImageKey] && announcement.image[croppedImageKey].url
                  ? announcement.image[croppedImageKey].url
                  : (announcement.image[size] ? announcement.image[size].url : "");

  return (
    <div className="promotion-card">
      <img className="promotion-card-image" src={imageUrl} alt="" />
      <div className="promotion-card-container">
        <p className="promotion-card-date"> {dateLabel} </p>
        <div className="promotion-card-header">{announcement.title}</div>
        <div className="promotion-card-title">{announcement.subtitle}</div>
        <div className="promotion-card-content">
          <p className="promotion-card-content-text"></p>
          <CustomButton
            className="promotion-card-content-link"
            link
            tight
            to={"/news/" + announcement.id}
          >
            Saiba mais
            <ArrowRightSM />
          </CustomButton>
        </div>
      </div>
    </div>
  );
  
}


export default Preview
